import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 5v15h3","key":"svg-0"}],["path",{"d":"M16 4h3v11m0 4v1h-3","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

const IconBracketsOff = createReactComponent('outline', 'brackets-off', 'BracketsOff', __iconNode);

export default IconBracketsOff;